'use strict'

module.exports = [
    '$scope',
    '$mdDialog',
    'count',
    ($scope, $mdDialog, count) => {

        $scope.cancel = data => $mdDialog.cancel(data)
        $scope.ok = data => $mdDialog.hide(data)

        $scope.count = count
        $scope.radioModel = 'moveItems'

    }
]
